import React from 'react';
import * as PropTypes from 'prop-types';
import ChromeReaderModeIcon from '@material-ui/icons/ChromeReaderMode';
import { SubjectPropType } from '../../../abilities/proptypes';
import SendMailButton from './SendMailButton';
import { INFOMATERIAL_ENTITY } from '../../../mailTemplates/entities';
import { IdPropType } from '../../../../proptypes/basic';

const SendInfomaterialButton = ({
    name,
    customerId,
    onSent,
    disabled,
    subject,
    action,
    className,
    variant,
    color,
    size,
}) => {
    // SendMailForm already marks the customer record (infomaterialSentAt /
    // infomaterialSentVia) for every successful INFOMATERIAL_ENTITY send, so
    // this button only needs to forward the caller's own onSent (e.g. to bump
    // a reminder date) - it must not duplicate that bookkeeping here.
    return (
        <SendMailButton
            name={name}
            startIcon={<ChromeReaderModeIcon />}
            variant={variant}
            color={color}
            disabled={disabled}
            action={action}
            subject={subject}
            entity={INFOMATERIAL_ENTITY}
            entityId={customerId}
            onSent={onSent}
            className={className}
            size={size}
            label="Infopaket versenden E-Mail"
        />
    );
};

SendInfomaterialButton.propTypes = {
    customerId: IdPropType.isRequired,
    onSent: PropTypes.func,
    disabled: PropTypes.bool,
    subject: SubjectPropType,
    action: PropTypes.string,
    variant: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string,
    className: PropTypes.string,
};

SendInfomaterialButton.defaultProps = {
    onSent: null,
    disabled: false,
    subject: null,
    action: null,
    variant: undefined,
    color: undefined,
    size: undefined,
    className: null,
};

export default SendInfomaterialButton;
